module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/191-tonga-50b788c0ae5d03fcc3bc2fa77cb79ede.svg";